/** Marque Ligam — L stylisé (traits arrondis). */
export const BRAND_ICON_VIEWBOX = '0 0 24 24';

export const BRAND_STROKE_WIDTH = 2.4;

/** L stylisé : descente verticale + base horizontale, jointure arrondie. */
export const BRAND_ICON_L = 'M7.5 4 V19.5 H19';
